class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  // renderContents(parsedState) {
  //   this.cartItemKey = parsedState.key;
  //   this.getSectionsToRender().forEach((section) => {
  //     document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
  //       parsedState.sections[section.id],
  //       section.selector
  //     );
  //   });

  //   if (this.header) this.header.reveal();
  //   this.open();
  // }

  // custom code start 

  renderContents(parsedState) {
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {

    const sectionElement =
      document.getElementById(section.id);

    if (!sectionElement) return;

    sectionElement.innerHTML =
      this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

  });


  if (this.header) {
    this.header.reveal();
  }


  /*
   * Open notification first.
   */

  this.open();


  /*
   * Wait until Dawn has finished replacing
   * the notification HTML.
   *
   * Then fetch the REAL current cart.
   */

  requestAnimationFrame(() => {

    requestAnimationFrame(() => {

      if (
        typeof window.TurfGloUpdateCartNotification ===
        'function'
      ) {

        window.TurfGloUpdateCartNotification();

      }

    });

  });

}

// custom code end 

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// custom code 

/* =========================================
   TURFGLO — CART NOTIFICATION
   DYNAMIC FREE DELIVERY
========================================= */

(function () {

  const FREE_DELIVERY_THRESHOLD = 13900;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(cents / 100);
  }


  async function updateCartNotificationFreeDelivery() {

    const container = document.querySelector(
      '#TG-CartNotification-FreeDelivery'
    );

    if (!container) return;


    try {

      const response = await fetch(
        '/cart.js',
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          cache: 'no-store'
        }
      );


      if (!response.ok) {
        throw new Error('Unable to fetch cart');
      }


      const cart = await response.json();

      const cartTotal = Number(
        cart.total_price || 0
      );


      /* ==============================
         FREE DELIVERY UNLOCKED
      ============================== */

      if (cartTotal >= FREE_DELIVERY_THRESHOLD) {

        container.innerHTML = `
          <div class="tg-cart-notification-free-delivery tg-unlocked">

            <span class="tg-cart-notification-free-delivery__icon">
              ✓
            </span>

            <span>
              You've unlocked free delivery.
            </span>

          </div>
        `;

        return;
      }


      /* ==============================
         FREE DELIVERY NOT UNLOCKED
      ============================== */

      const remaining =
        FREE_DELIVERY_THRESHOLD - cartTotal;


      container.innerHTML = `
        <div class="tg-cart-notification-free-delivery">

          <span class="tg-cart-notification-free-delivery__icon">
            ↑
          </span>

          <span>
            You're
            <strong>
              ${formatMoney(remaining)}
            </strong>
            away from free delivery.
          </span>

        </div>
      `;


    } catch (error) {

      console.error(
        'TurfGlo notification free delivery error:',
        error
      );

    }

  }


  /*
   * Expose globally so CartNotification
   * can call it after renderContents().
   */

  window.TurfGloUpdateCartNotification =
    updateCartNotificationFreeDelivery;

})();
